import { useFocusEffect } from "@react-navigation/native";
import { useCallback, useContext } from "react";
import { SafeAreaManagerContext } from "../contexts/SafeAreaManager";

export const useStatusBarTranslucent = () => {
    const { setStatusBarTranslucent } = useContext(SafeAreaManagerContext);

    useFocusEffect(
        useCallback(() => {
            setStatusBarTranslucent(false);
            return () => {
                setStatusBarTranslucent(true);
            };
        }, [setStatusBarTranslucent]),
    );
};
